import { Action, State, StateContext } from "@ngxs/store";
import { ProOrganizerRequestEntity } from "../../domains/pro-organizer-request-data";
import { ProOrganizerRequestsService } from "@smatchy/sdk";
import { FindProOrganizerRequestByUser, FindProOrganizerRequestByUserFailure, FindProOrganizerRequestByUserSuccess } from "./find-by-user.actions";
import { catchError, tap, throwError } from "rxjs";
import { Injectable } from "@angular/core";

export interface FindProOrganizerRequestByUserInitialState {
    loading: boolean;
    data: ProOrganizerRequestEntity[];
    error: unknown;
}

@State<FindProOrganizerRequestByUserInitialState>({
    name: 'proOrganizerRequestByUser',
    defaults: {
        loading: false,
        data: [],
        error: null
    }
})
@Injectable()
export class FindProOrganizerRequestByUserState {
    constructor(private service: ProOrganizerRequestsService) {}

    @Action(FindProOrganizerRequestByUser)
    findProOrganizerRequestByUser(ctx: StateContext<FindProOrganizerRequestByUserInitialState>) {
        ctx.patchState({ loading: true, error: null });
        return this.service
            .getRequestByUser()
            .pipe(
                tap((res) => {
                    console.log('[FindProOrganizerRequestByUser] API success:', res);
                    ctx.dispatch(new FindProOrganizerRequestByUserSuccess((res as { data: ProOrganizerRequestEntity[] })?.data as ProOrganizerRequestEntity[]));
                }),
                catchError((err: unknown) => {
                    console.error('[FindProOrganizerRequestByUser] API error:', err);
                    ctx.dispatch(new FindProOrganizerRequestByUserFailure(err));
                    return throwError(() => err);
                }),
            );
    }

    @Action(FindProOrganizerRequestByUserSuccess)
    findProOrganizerRequestByUserSuccess(ctx: StateContext<FindProOrganizerRequestByUserInitialState>, action: FindProOrganizerRequestByUserSuccess) {
        console.log('[FindProOrganizerRequestByUser] API success:', action.data);
        ctx.patchState({ loading: false, data: action.data });
    }

    @Action(FindProOrganizerRequestByUserFailure)
    findProOrganizerRequestByUserFailure(ctx: StateContext<FindProOrganizerRequestByUserInitialState>, action: FindProOrganizerRequestByUserFailure) {
        console.error('[FindProOrganizerRequestByUser] API error:', action.error);
        ctx.patchState({ loading: false, error: action.error });
    }
}